module.exports = __webpack_public_path__ + "static/media/granizo.93d9bd06.jpg";